import { Component, ViewChild } from '@angular/core';
import { PatientService } from "../../../core/services/patient.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ModalV2Component } from "../../../shared/modal-v2/modal-v2.component";
import { AlertService } from "../../../shared/alert/alert.service";
import { LogHelper } from "../../../core/helpers/log.helper";
import { requiredNoWhitespaceValidator } from "../../../core/validators/no-whitespace.validator";

@Component({
  selector: 'app-patient-set-password-modal',
  templateUrl: './patient-set-password-modal.component.html',
  styleUrls: ['./patient-set-password-modal.component.scss']
})
export class PatientSetPasswordModalComponent {
  @ViewChild('modal') modal: ModalV2Component;

  protected form = new FormGroup({
    isBusy: new FormControl<boolean>(false),
    patientTrialId: new FormControl<string>(null, Validators.required),
    confirmed: new FormControl<boolean>(false, Validators.requiredTrue),
    password: new FormControl<string>('', requiredNoWhitespaceValidator()),
    confirmPassword: new FormControl<string>('', requiredNoWhitespaceValidator()),
  }, { validators: passwordMatchValidator });

  constructor(private _patientService: PatientService, private _alertService: AlertService) {}

  show(patientTrialId: string) {
    this.form.patchValue({
      patientTrialId: patientTrialId,
      isBusy: false,
      password: null,
      confirmPassword: null
    });
    this.modal.show();
  }

  onFormSubmit() {
    if (!this.form.valid)
      return;

    this.form.patchValue({isBusy: true});
    this._patientService.setPatientPassword(this.form.get('patientTrialId').value, this.form.get('password').value).subscribe({
      next: (rsp) => {
        this.form.patchValue({isBusy: false});
        this.modal.hide();
        this._alertService.showSuccessAlert('The patient password has been set.');
      },
      error: (err) => {
        LogHelper.log(err);
        this.form.patchValue({isBusy: false});
        this._alertService.showErrorAlert(err);
      }
    });
  }
}

function passwordMatchValidator(group: FormGroup) {
  const password = group.get('password')?.value;
  const confirmPassword = group.get('confirmPassword')?.value;

  if (password && confirmPassword && password !== confirmPassword) {
    group.get('confirmPassword')?.setErrors({ passwordMismatch: true });
    return { passwordMismatch: true };
  } else {
    // Only clear passwordMismatch error, not others
    const errors = group.get('confirmPassword')?.errors;
    if (errors && errors['passwordMismatch']) {
      delete errors['passwordMismatch'];
      if (Object.keys(errors).length === 0) {
        group.get('confirmPassword')?.setErrors(null);
      } else {
        group.get('confirmPassword')?.setErrors(errors);
      }
    }
    return null;
  }
}
